import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, TruckIcon, CreditCardIcon } from 'lucide-react';
import { packColors, packContents, upsellOptions, UpsellOption, getCheckoutUrl } from '../data/copy';
import { CtaButton } from './CtaButton';
type OfferProps = {
  selectedUpsell: UpsellOption;
  onSelectUpsell: (option: UpsellOption) => void;
};
export function Offer({
  selectedUpsell,
  onSelectUpsell
}: OfferProps) {
  const checkoutUrl = getCheckoutUrl(selectedUpsell.variantId, selectedUpsell.quantity);
  return <section className="relative w-full scroll-mt-16 bg-abyss py-12 sm:py-24" aria-labelledby="pack-title" id="pack" data-id="element-86" data-mp="p11z8i9u1jxg">
      <div className="mx-auto max-w-6xl px-4 sm:px-8" data-id="element-87" data-mp="13uogeq97hzde">
        <div className="grid items-stretch gap-0 border-2 border-chartreuse/60 bg-steel lg:grid-cols-2" data-id="element-88" data-mp="yx51do4opike">
          <div className="relative h-60 overflow-hidden border-b-2 border-chartreuse/40 sm:h-auto sm:min-h-[340px] lg:border-b-0 lg:border-r-2" data-id="element-89" data-mp="2famsz43lf3jd">
            <img src="https://cdn.magicpatterns.com/uploads/5edz4esTMMoHMBu1fVVUet/pack_de_30_senuelos.png" alt="Bolsa resellable con el Pack de 30 señuelos Charly Baits sobre una mesa de madera" className="h-full w-full bg-abyss object-contain object-center" data-id="element-90" data-mp="pk7fjklocj8x" />
            <span className="absolute right-3 top-3 bg-blood px-3 py-1.5 font-display text-xs uppercase tracking-widest text-bone sm:right-4 sm:top-4 sm:px-4 sm:py-2 sm:text-sm" data-id="element-91" data-mp="13ki6enmzhxu3">
              Lote limitado
            </span>
          </div>

          <div className="p-5 sm:p-10" data-id="element-92" data-mp="btc0fqkl15ww">
            <p className="font-cond text-xs uppercase tracking-[0.28em] text-chartreuse sm:text-sm" data-id="element-93" data-mp="fuffwbypwzxl">
              La oferta
            </p>
            <h2 id="pack-title" className="mt-2 font-display text-2xl uppercase leading-[0.95] text-bone sm:mt-3 sm:text-4xl" data-id="element-94" data-mp="klxkd9zy9inb">
              Pack Pro-Series
              <span className="block text-chartreuse" data-id="element-95" data-mp="3o8win45zahx9">30 piezas</span>
            </h2>

            <p className="mt-4 font-body text-[0.95rem] leading-relaxed text-bone/75 sm:mt-5 sm:text-base" data-id="element-96" data-mp="vez3sxww5r53">
              Es el arsenal completo: los tres modelos que arman el día
              —Pitbull, Senko y Cangrejo— en las combinaciones de color que
              sacan trofeo a mediodía, en agua turbia y en cristal. Treinta
              piezas. Una sola lobina de 5 libras te lo paga en recuerdo.
            </p>

            <ul className="mt-5 space-y-2 sm:mt-7 sm:space-y-2.5" data-id="element-97" data-mp="chelk9omtqtg">
              {packContents.map(item => <li key={item} className="flex items-start gap-2.5 font-body text-[0.9rem] text-bone/85 sm:gap-3 sm:text-base" data-id="element-98" data-mp="7jmmmvpkl4fr">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-chartreuse" aria-hidden="true" data-id="element-99" data-mp="heeh3qnuvb6b" />
                  {item}
                </li>)}
            </ul>

            <p className="mt-5 font-cond text-xs uppercase tracking-[0.28em] text-bone/60 sm:text-sm" data-id="element-100" data-mp="1sxhaq2gt35kd">
              Colores
            </p>
            <ul className="mt-2 flex flex-wrap gap-2" data-id="element-101" data-mp="25erzo6nj4lg5">
              {packColors.map(color => <li key={color} className="border border-bone/20 px-2.5 py-1 font-cond text-[0.8rem] uppercase tracking-wide text-bone/85 sm:text-sm" data-id="element-102" data-mp="1qhj5l56ud3kq">
                  {color}
                </li>)}
            </ul>

            <div className="mt-8 flex flex-col gap-3" data-id="element-103" data-mp="2o4rjae0lp8c6">
              {upsellOptions.map(opt => {
              const isSelected = selectedUpsell.id === opt.id;
              return <label key={opt.id} className={`relative flex cursor-pointer flex-col gap-1 rounded-sm border-2 p-4 transition-all ${isSelected ? 'border-chartreuse bg-chartreuse/5' : opt.highlight ? 'border-chartreuse/40 bg-abyss hover:border-chartreuse/70' : 'border-bone/10 bg-abyss hover:border-bone/30'}`} data-id="element-104" data-mp="2edwx19ncu8qq">
                    <input type="radio" name="upsell" value={opt.id} checked={isSelected} onChange={() => onSelectUpsell(opt)} className="sr-only" data-id="element-105" data-mp="197f7j8ubz9de" />
                    {opt.highlight && <span className="absolute -top-3 left-4 bg-chartreuse px-2 py-0.5 font-display text-[0.65rem] uppercase tracking-widest text-abyss" data-id="element-106" data-mp="1wzw04dbp2jqy">
                        {opt.highlight}
                      </span>}
                    <div className="flex items-start justify-between gap-4" data-id="element-107" data-mp="2knx5jddktk25">
                      <div className="flex items-start gap-3" data-id="element-108" data-mp="2fwnhgh7oeosd">
                        <div className={`mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border ${isSelected ? 'border-chartreuse' : 'border-bone/40'}`} data-id="element-109" data-mp="2fvcc4cyl18z5">
                          {isSelected && <div className="h-2.5 w-2.5 rounded-full bg-chartreuse" data-id="element-110" data-mp="2x4enqglccafs" />}
                        </div>
                        <div className="flex flex-col" data-id="element-111" data-mp="322zku75aqe00">
                          <span className="font-display text-lg uppercase leading-none text-bone sm:text-xl" data-id="element-112" data-mp="37344u75exquz">
                            {opt.title}
                          </span>
                          {opt.subtitle && <span className="mt-1.5 font-body text-[0.85rem] leading-tight text-bone/70 sm:text-sm" data-id="element-113" data-mp="3fx91j7789wif">
                              {opt.subtitle}
                            </span>}
                          {opt.badge && <span className="mt-2.5 inline-flex w-fit items-center gap-1 rounded-sm bg-water px-2 py-0.5 font-cond text-[0.65rem] uppercase tracking-wider text-chartreuse sm:text-xs" data-id="element-114" data-mp="3uut281x3d5is">
                              <TruckIcon className="h-3 w-3" data-id="element-115" data-mp="307khnjyz3ix1" />
                              {opt.badge}
                            </span>}
                        </div>
                      </div>
                      <div className="flex shrink-0 flex-col items-end text-right" data-id="element-116" data-mp="3a34cs45pqdkq">
                        {opt.originalPrice && <span className="font-cond text-xs uppercase text-ash line-through sm:text-sm" data-id="element-117" data-mp="3ix0vf8zo57ve">
                            ${opt.originalPrice}
                          </span>}
                        <span className="font-display text-2xl text-chartreuse sm:text-3xl" data-id="element-118" data-mp="3svgcsk8w92rp">
                          ${opt.price}
                        </span>
                      </div>
                    </div>
                  </label>;
            })}
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-3 font-cond text-xs uppercase text-bone/60 sm:mt-8 sm:text-sm" data-id="element-119" data-mp="dz4sg04dmdmr">
              <span className="flex items-center gap-1.5" data-id="element-120" data-mp="iyhj6vydc4um">
                <CreditCardIcon className="h-4 w-4" data-id="element-121" data-mp="j010mpvrglxz" />
                Tarjetas
              </span>
              <span className="flex items-center gap-1.5" data-id="element-122" data-mp="47h5ocirlkrm">
                <span className="font-display text-xs tracking-wider" data-id="element-123" data-mp="96tuv3x3z3xd">OXXO</span>
              </span>
              <span className="flex items-center gap-1.5" data-id="element-124" data-mp="3rcgb9mi7z62u">
                SPEI
              </span>
              <span className="text-chartreuse/80" data-id="element-125" data-mp="3vh65l6x8ccln">Pago 100% seguro</span>
            </div>

            <CtaButton size="md" source="pack" href={checkoutUrl} itemName={selectedUpsell.title} value={selectedUpsell.price} className="mt-5 w-full sm:hidden" data-id="element-126" data-mp="3hh53xp955154">
              ¡Quiero pescar más ya! → ${selectedUpsell.price}
            </CtaButton>
            <CtaButton source="pack" href={checkoutUrl} itemName={selectedUpsell.title} value={selectedUpsell.price} className="mt-7 hidden w-full sm:inline-flex" data-id="element-127" data-mp="1knjrbvbqchds">
              ¡Quiero pescar más ya! → ${selectedUpsell.price}
            </CtaButton>

            <p className="mt-3 flex items-start gap-2 font-body text-xs text-bone/60 sm:mt-4 sm:text-sm" data-id="element-128" data-mp="3fn8jbv1t1j8">
              <TruckIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-129" data-mp="3us81phaf1tvd" />
              Enviamos a todo México. Sale del taller en 24 horas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}